export const createMeterReading = `
    mutation createMeterReading($input: CreateMeterReadingInput!) {
        createMeterReading(input:$input) {
            id
            customerId
            meterId
            meterValue
            timestamp
            dimensions {
                apiKey
                value
            }
            created
            updated
    }
}`;

export const updateMeterReading = `
    mutation updateMeterReading($input: UpdateMeterReadingInput!) {
        updateMeterReading(input:$input){
            id
            customerId
            meterId
            meterValue
            timestamp
            dimensions {
                apiKey
                value
            }
            created
            updated
        }
}`;

export const deleteMeterReading = `
    mutation deleteMeterReading($input: DeleteMeterReadingInput!) {
        deleteMeterReading(input:$input)
}`;
